import { Roles, Status } from "@/models/user.model";

export var statusDropdown = {
  options: [
    { name: "Ativo", code: Status.ACTIVATED },
    // { name: "Inativo", code: Status.INACTIVATED },
    { name: "Bloqueado", code: Status.BLOCKED },
    { name: "Aguardando", code: Status.WAITING_ACTIVATION },
  ],
  value: null,
};

export var roleDropdown = {
  options: [
    { name: "Administrador", code: Roles.ADMINISTRATOR },
    { name: "Aluno", code: Roles.STUDENT },
    { name: "Professor", code: Roles.TEACHER },
  ],
  value: null,
};

export const userColumns = [
  { name: "Nome do usuário", value: "name", filter: true },
  { name: "Usuário", value: "role", filter: true },
  { name: "E-mail", value: "login", filter: true },
  { name: "Organização", value: "organization", filter: true },
  { name: "Status", value: "status", filter: true },
];

export const userActions = [
  {
    title: null,
    icon: "hi-solid-pencil",
    type: "edit",
    style: "btn-simple",
    tooltip: "Editar",
  },
];

export const users_template = [
  { "E-mail": "teste.email@teste.com" },
];
